import { isServer } from '@/app/src/shared/lib/isServerClient'
import { STICKY_ANCHOR_DATA_NAME, STICKY_NAVIGATION_SCROLL_CONTAINER_NAME } from './config'
import { replaceSpaces } from '@/app/src/shared/lib/replaceSpaces'
import { getFullUrl } from '@/app/src/shared/lib/getFullUrl'
import variables from '@/app/src/app/scss/abstracts/export.module.scss'
import { INextLink } from '@/app/src/shared/model'
import { IStickyLink } from '@/app/src/widgets/Layout/StickyNavigation/model'

const { headerHeadroomWithStickyNavigation, stickyNavigationHeight } = variables

export const parseAnchors = (rootElName = 'body'): string[] => {
  if (isServer) return []

  const root = document.querySelector(rootElName)
  const anchorsEls = root?.querySelectorAll(
    `[${STICKY_ANCHOR_DATA_NAME}]`,
  ) as unknown as HTMLElement[]

  const anchorsArr = anchorsEls ? Array.from(anchorsEls) : []

  return anchorsArr.map((item) => item?.dataset?.stickyTitle ?? '').filter((item) => item !== '')
}

export const createNavigation = (anchors: string[]): IStickyLink[] => {
  if (isServer) return []

  const hash = window.location?.hash || ''
  const id = hash ? hash.substring(1) : null

  const { url } = getFullUrl()

  return anchors.map((anchor, key) => ({
    id: replaceSpaces(anchor as string),
    title: anchor,
    href: `/${url}#${encodeURIComponent(replaceSpaces(anchor as string))}` as INextLink,
    isActive: id ? replaceSpaces(anchor as string) === id : key === 0,
  }))
}

export const scrollNavToCenter = (el: HTMLDivElement | null) => {
  if (isServer) return
  if (!el) return

  const scrollContainer = document.querySelector(`#${STICKY_NAVIGATION_SCROLL_CONTAINER_NAME}`)

  const containerRect = scrollContainer?.getBoundingClientRect()
  const containerRectLeft = containerRect?.left || 0

  const elementRect = el.getBoundingClientRect()
  const elementRectLeft = elementRect?.left || 0

  const containerWidth = containerRect?.width || 0
  const elementWidth = elementRect?.width || 0

  const offset = elementRectLeft - containerRectLeft - containerWidth / 2 + elementWidth / 2

  scrollContainer?.scrollTo({
    left: scrollContainer.scrollLeft + offset,
    behavior: 'smooth',
  })
}

export const checkTop = (el: HTMLDivElement | null) => {
  if (!el) return

  const navigationHeight = parseInt(stickyNavigationHeight) - 2
  const navigationWithHeadroomHeight = parseInt(headerHeadroomWithStickyNavigation) - 2

  const rect = el.getBoundingClientRect()
  const isTop = rect.top <= navigationWithHeadroomHeight && rect.top >= navigationHeight

  return isTop
}

export const checkDirection = (
  prevIndex: number,
  currentIndex: number,
): 'to-top' | 'to-bottom' | 'not-changed' => {
  if (prevIndex < currentIndex) {
    return 'to-bottom'
  }

  if (prevIndex > currentIndex) {
    return 'to-top'
  }

  return 'not-changed'
}
